module.exports = __webpack_public_path__ + "img/jl_dd@2x.ce7d3fa6.png";